import React, { forwardRef, useState } from "react";

/**
 * Password input with a show/hide eye toggle.
 * Accepts all standard <input> props; toggles `type` between "password" and "text".
 *
 *   <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} required />
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className, ...props },
  ref
) {
  const [shown, setShown] = useState(false);
  return (
    <div className="password-input-wrap">
      <input
        {...props}
        ref={ref}
        type={shown ? "text" : "password"}
        className={className}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setShown((s) => !s)}
        tabIndex={-1}
        aria-label={shown ? "Hide password" : "Show password"}
        title={shown ? "Hide" : "Show"}
      >
        {shown ? (
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
});

export default PasswordInput;
